import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useLang } from "@/lib/i18n";

const SITE_URL = "https://alightracing.com";
const OG_IMAGE = `${SITE_URL}/images/misc/hero-car.jpg`;

export const Seo = ({ title, description, noindex = false, jsonLd = null }) => {
  const { pathname } = useLocation();
  const { lang } = useLang();
  React.useEffect(() => {
    // Remove static fallback tags from index.html so Helmet-managed tags are the only source of truth at runtime
    document.querySelectorAll("meta[data-static-seo]").forEach((el) => el.remove());
  }, []);
  const canonical = `${SITE_URL}${pathname === "/" ? "/" : pathname}`;
  return (
    <Helmet>
      <html lang={lang === "pt" ? "pt-BR" : "en"} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Alight Racing" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:locale" content={lang === "pt" ? "pt_BR" : "en_US"} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};
